import styled from 'styled-components';
import { PriceBoxStyledOV as PriceBoxStyled } from '../PriceBoxStyled.OV';

export const PriceBoxStyledOV = styled(PriceBoxStyled)`
 
`;
